import { render, staticRenderFns } from "./RecuperarSenhaIdentificacao.vue?vue&type=template&id=5731be42&scoped=true"
import script from "./RecuperarSenhaIdentificacao.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaIdentificacao.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaIdentificacao.vue?vue&type=style&index=0&id=5731be42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731be42",
  null
  
)

export default component.exports